import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';

import { Input } from '../../../components';
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Text,
} from '@chakra-ui/react';

export const ResetPassword: FC<{
  register: UseFormRegister<any>;
  isPasswordMatch: boolean;
  onSubmit: () => void;
  isFirstPassword?: boolean;
  isLoading?: boolean;
}> = ({ register, isPasswordMatch, onSubmit, isFirstPassword, isLoading }) => {
  return (
    <>
      <Box textAlign="center" maxW="24rem" mx="auto">
        <Heading as="h3" fontSize="3xl" color="custom_blue.1" mb="12px">
          {isFirstPassword ? 'Set New password' : 'Reset password'}{' '}
        </Heading>
        <Text fontSize="md" mb="2rem" color="custom_gray.1">
          Now you should be able to enter a new password for your account.{' '}
        </Text>
        <form onSubmit={onSubmit}>
          <FormControl mb="2rem">
            <FormLabel htmlFor='password' fontSize="1rem">New password</FormLabel>
            <Input
              required
              type="password"
              name="password"
              id="password"
              register={register}
            />
          </FormControl>
          <FormControl isInvalid={!isPasswordMatch}>
            <FormLabel htmlFor="confirmPassword" fontSize="1rem">
              Confirm new password
            </FormLabel>
            <Input
              required
              type="password"
              name="confirmPassword"
              id="confirmPassword"
              register={register}
            />
            <FormErrorMessage mt="4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.3387 10.3919L7.20523 0.588572C7.01561 0.226721 6.64083 0 6.23231 0C5.82379 0 5.44901 0.226721 5.25939 0.588572L0.125401 10.3919C-0.0529635 10.7324 -0.0403376 11.1414 0.158691 11.4703C0.35772 11.7992 0.71419 12.0001 1.0986 12H11.3655C11.7499 12.0001 12.1063 11.7992 12.3054 11.4703C12.5044 11.1414 12.517 10.7324 12.3387 10.3919ZM5.68283 4.03377C5.68283 3.73045 5.92872 3.48456 6.23204 3.48456C6.53535 3.48456 6.78124 3.73045 6.78124 4.03377V7.32901C6.78124 7.63233 6.53535 7.87822 6.23204 7.87822C5.92872 7.87822 5.68283 7.63233 5.68283 7.32901V4.03377ZM6.24412 10.3551H6.2595C6.47759 10.3516 6.68504 10.2603 6.83492 10.1018C6.98481 9.94336 7.06445 9.73115 7.05585 9.5132C7.03817 9.06359 6.66882 8.70805 6.21886 8.70751H6.20348C5.98593 8.71149 5.77911 8.80277 5.62955 8.9608C5.47998 9.11883 5.40023 9.33036 5.40823 9.5478C5.42531 9.99751 5.79409 10.3537 6.24412 10.3551Z"
                  fill="#FF3654"
                />
              </svg>{' '}
              <Text as="span"  marginInlineStart="3" fontSize="sm">
                The password confirmation does not match
              </Text>
            </FormErrorMessage>
          </FormControl>
          <Box className="mt-6 w-full" width="full" mt="2rem">
            <Button
              type="submit"
              bg="custom_orange.2"
              _hover={{ bg: 'custom_orange.2' }}
              color="white"
              fontWeight="semibold"
              fontSize="sm"
              w="full"
              isLoading={isLoading}
            >
              {' '}
              {isFirstPassword ? 'Set' : 'Reset'} Password
            </Button>
          </Box>
        </form>
      </Box>
    </>
  );
};
